import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _difference from "lodash/difference";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import { createPortal } from 'react-dom';
import nullthrows from "../lib/nullthrows";
import AlignContext, { inertAlignContextProps } from "../Align/AlignContext";
import FocusTrap from "../FocusTrap";

/**
 * The top-level DOM node containing all Portal mount targets.
 */
var layerRoot = null;
/**
 * A stack of Layer instances, for use with handling events in proper Layer
 * ancestry order.
 */

var layerStack = []; // eslint-disable-line no-use-before-define

var body = function body() {
  return nullthrows(document.body);
};

var handleClick = function handleClick(e) {
  var target = e.target;

  if (!(target instanceof Node)) {
    return;
  }

  var ancestors = getAncestorLayersForNode(layerStack, target);

  var nonAncestors = _difference(layerStack, ancestors);

  for (var ii = nonAncestors.length - 1; ii >= 0; ii--) {
    var layer = nonAncestors[ii];
    var node = layer.getContainerDOMNode();

    if (node && !node.contains(target)) {
      var result = layer.onClickOutside(e);

      if (result === 'handled') {
        return;
      }
    }
  }
};

var handleScroll = function handleScroll(e) {
  layerStack.forEach(function (layer) {
    layer.onScroll(e);
  });
};

var handleResizeWindow = function handleResizeWindow(e) {
  layerStack.forEach(function (layer) {
    layer.onResizeWindow(e);
  });
};

var addBodyListeners = function addBodyListeners() {
  body().addEventListener('click', handleClick, false);
  window.addEventListener('scroll', handleScroll, true);
  window.addEventListener('resize', handleResizeWindow, false);
};

var removeBodyListeners = function removeBodyListeners() {
  body().removeEventListener('click', handleClick, false);
  window.removeEventListener('scroll', handleScroll, true);
  window.removeEventListener('resize', handleResizeWindow, false);
};

var LayerContext = React.createContext(null);

var Layer = /*#__PURE__*/function (_React$Component) {
  _inherits(Layer, _React$Component);

  var _super = _createSuper(Layer);

  function Layer(props) {
    var _this;

    _classCallCheck(this, Layer);

    _this = _super.call(this, props);
    _this.layer = void 0;
    _this.targetNode = void 0;
    _this.node = void 0;
    _this.parentLayer = void 0;

    _this.layerRef = function (node) {
      _this.node = node;
    };

    _this.handleStop = function (e) {
      e.stopPropagation();
    };

    _this.targetNode = document.createElement('div');

    if (!layerRoot) {
      var node = document.createElement('div');
      body().appendChild(node);
      addBodyListeners();
      layerRoot = node;
    }

    layerRoot.appendChild(_this.targetNode); // Add this Layer instance to the stack even if it has not yet rendered.

    layerStack = layerStack.concat(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Layer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // At this point, `layerRoot` should always be an element. This is in place
      // for Flow refinement.
      if (!layerRoot) {
        return;
      }

      var index = layerStack.indexOf(this);
      var newStack = layerStack.slice();

      if (index !== -1) {
        newStack.splice(index, 1);
      }

      layerStack = newStack; // We're done with this portal mount target, so we can remove it from the
      // DOM.

      layerRoot.removeChild(this.targetNode); // If all children have been removed, we have no more layers and can
      // unhook everything.

      if (layerRoot.childNodes.length === 0) {
        body().removeChild(layerRoot);
        removeBodyListeners();
        layerRoot = null;
      }
    }
  }, {
    key: "getParentLayer",

    /**
     * These methods are only for use within the static event handler
     * functions within Layer code. Do not use externally!
     */
    value: function getParentLayer() {
      return this.parentLayer;
    }
  }, {
    key: "getContainerDOMNode",
    value: function getContainerDOMNode() {
      return this.node;
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      var onClickOutside = this.props.onClickOutside;

      if (onClickOutside) {
        return onClickOutside(e);
      }

      return 'not-handled';
    }
  }, {
    key: "onScroll",
    value: function onScroll(e) {
      var onScroll = this.props.onScroll;

      if (onScroll) {
        onScroll(e);
      }
    }
  }, {
    key: "onResizeWindow",
    value: function onResizeWindow(e) {
      var onResizeWindow = this.props.onResizeWindow;

      if (onResizeWindow) {
        onResizeWindow(e);
      }
    }
    /**
     * As of React 16, first-class portals bubble events up to parent components.
     * This can lead to unexpected behavior, especially where parent components
     * have event listeners that trigger layers to open or close. For instance, a
     * click on an element might open a flyout, but a click on a "Close" button
     * within that flyout could bubble up to the parent element, causing it to stay
     * open.
     *
     * It's easier to think of portals as being the top level for all event
     * bubbling for events occurring within the portal, since that's conceptually
     * similar to expected DOM behavior. To that end, we stop propagation on
     * bubbling events here.
     *
     * The list of handlers defined in `render` is based on
     * https://en.wikipedia.org/wiki/DOM_events#Events. It is not exhaustive since
     * callsites don't generally use the full set of events, but it aims to
     * cover some of the more common and obvious potential problem cases.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LayerContext.Consumer, null, function (parentLayer) {
        _this2.parentLayer = parentLayer; // Checks that layer has content and is trapFocus is explicitly true

        var hasFocusTrap = _this2.props.trapFocus && !!_this2.node;
        return /*#__PURE__*/React.createElement(LayerContext.Provider, {
          value: _this2
        }, /*#__PURE__*/React.createElement(AlignContext.Provider, {
          value: inertAlignContextProps
        }, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
          onMouseDown: _this2.handleStop,
          onMouseUp: _this2.handleStop,
          onChange: _this2.handleStop,
          onClick: _this2.handleStop,
          onKeyDown: _this2.handleStop,
          onKeyPress: _this2.handleStop,
          onKeyUp: _this2.handleStop,
          onSubmit: _this2.handleStop,
          ref: _this2.layerRef
        }, /*#__PURE__*/React.createElement(FocusTrap, {
          className: _this2.props.className,
          trapFocus: hasFocusTrap,
          returnFocus: _this2.props.returnFocus,
          focusContainer: _this2.props.focusContainer
        }, React.Children.only(_this2.props.children))), _this2.targetNode)));
      });
    }
  }]);

  return Layer;
}(React.Component);

Layer.defaultProps = {
  returnFocus: false,
  trapFocus: false
};
export function getAncestorLayersForNode(layerStack, target) {
  var stack = layerStack.slice();
  var targetLayer = stack.reverse().find(function (layer) {
    var node = layer.getContainerDOMNode();
    return !!(node && node.contains(target));
  });

  if (!targetLayer) {
    return [];
  }

  var ancestors = [];
  var layerToCheck = targetLayer;

  while (layerToCheck) {
    ancestors.push(layerToCheck);
    layerToCheck = layerToCheck.getParentLayer();
  }

  return ancestors;
}
export default Layer;